import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Network } from '@ionic-native/network/ngx';
import { ToastController, Platform } from '@ionic/angular';

import { FirebaseService } from 'src/app/services/firebase.service';

export enum ConnectionStatus {
  Online,
  Offline
}

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(ConnectionStatus.Offline);

  constructor(
    private network: Network,
    private toastController: ToastController,
    private plt: Platform,
    private firebase: FirebaseService
  ) {
    this.plt.ready().then(() => {
      if (this.plt.is('cordova') || this.plt.is('mobileweb') || this.plt.is('mobile')) {
        this.initializeNetworkEvents();
        let status = this.network.type !== 'none' ? ConnectionStatus.Online : ConnectionStatus.Offline;
        this.status.next(status);
      }
    });
  }

  public initializeNetworkEvents() {
 
    this.network.onDisconnect().subscribe(() => {
      if (this.status.getValue() === ConnectionStatus.Online) {
        console.log('WE ARE OFFLINE');
        this.updateNetworkStatus(ConnectionStatus.Offline);
      }
    });
 
    this.network.onConnect().subscribe(() => {
      if (this.status.getValue() === ConnectionStatus.Offline) {
        console.log('WE ARE ONLINE');
        this.updateNetworkStatus(ConnectionStatus.Online);
      }
    });
  }
 
  private async updateNetworkStatus(status: ConnectionStatus) {
    this.status.next(status);

    this.firebase.logEvent("NetworkStatusUpdate", { status: this.status.value });
 
    let toast = this.toastController.create({
      message: status == ConnectionStatus.Offline ? 'No Internet connection is available. PODs will be stored locally until connectivity is restored.' : 'Connection restored.',
      duration: 3000,
      position: 'bottom'
    });
    toast.then(toast => toast.present());
  }
 
  public onNetworkChange(): Observable<ConnectionStatus> {
    return this.status.asObservable();
  }
 
  public getCurrentNetworkStatus(): ConnectionStatus {
    return this.status.getValue();
  }
}
